import { createContext, useCallback, useContext, useEffect, useState } from "react";

import { api } from "@/api";
import { GuidePanel } from "@/components/guide/GuidePanel";

const GuideContext = createContext(null);
export const useGuide = () => useContext(GuideContext);
export const imageUrl = (name) => `${api.defaults.baseURL}/guide/images/${name}`;
export const pagesForPath = (pages, path) => (pages || []).filter((p) => path.startsWith(p.screen));

export function GuideProvider({ children }) {
  const [data, setData] = useState({ pages: null, captures: {} });
  const [slug, setSlug] = useState(null);
  const [open, setOpen] = useState(false);
  const load = useCallback(() => api.get("/guide").then(({ data: d }) => setData(d)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const openGuide = (s = null) => { setSlug(s); setOpen(true); load(); };
  const value = { ...data, load, openGuide, setSlug, slug, open, setOpen };
  return (
    <GuideContext.Provider value={value}>
      {children}
      <GuidePanel />
    </GuideContext.Provider>
  );
}
